<style scoped>
.blocked-link {
  cursor: not-allowed;
}
</style>

<template>
  <v-list-item
    :class="{ 'blocked-link': !href }"
    :href="href"
  >
    <v-list-item-icon v-if="icon">
      <v-icon>{{ icon }}</v-icon>
    </v-list-item-icon>
    <v-list-item-title>{{ label }}</v-list-item-title>
  </v-list-item>
</template>

<script>
export default {
  name: 'AnchorSidebarItem',
  props: {
    icon: String,
    label: {
      type: String,
      required: true,
    },
    href: String,
  },
};
</script>
